<template>
  <div
    v-if="isTimeshiftEnabled"
    class="c-player-live-timeshift"
  >
    <div class="c-player-live-timeshift__progress">
      <ui-popover
        ref="popover"
        class="c-progress-bar__wrapper"
        @hover="hover"
      >
        <template #wrapper>
          <ui-track-bar
            :value="progress"
            :drag-limit="head"
            @changed="seek"
          ></ui-track-bar>
        </template>
        <template #content>
          <div class="c-progress-bar__popover">
            <ui-player-sprite
              v-if="isLiveSprite"
              :hover-time="hoverTimeFromUnixZeroSec"
              :sprites="sprites"
              :sprite-url="previewUrl"
              :preview-day="previewDay"
              is-channel
            ></ui-player-sprite>
            <div class="u-mt-5 u-text-center">
              {{ displayedHoverTime }}
            </div>
          </div>
        </template>
      </ui-popover>
    </div>
    <div class="c-player-live-timeshift__head">
      <ui-track-bar :value="head"></ui-track-bar>
    </div>
  </div>
</template>
<script>
  import { setSeekTo, state } from '@/shared/components/player/store';
  import UiTrackBar from '@/shared/components/track-bar/index.vue';
  import UiPopover from '@/shared/components/popover/index.vue';
  import { TimeshiftMode } from '@/shared/components/player/enums';
  import UiPlayerSprite from '@/shared/components/player/components/sprite/index.vue';
  import { ChannelSprites } from '@/shared/components/player/mixins';

  export default {
    name: 'UiPlayerLiveTimeShift',
    components: { UiPlayerSprite, UiPopover, UiTrackBar },
    mixins: [
      ChannelSprites,
    ],
    data() {
      return {
        displayedHoverTime: '',
        hoverTimeFromUnixZeroSec: 0,
        hoverTimeFromProgramStart: 0,
      };
    },
    computed: {
      isTimeshiftEnabled() {
        return state.timeshiftMode !== TimeshiftMode.DISABLED;
      },
      currentProgram() {
        return state.currentLiveProgram;
      },
      progress() {
        const progress = (state.progress / this.duration) * 100;
        if (progress >= 100) {
          return 100;
        }

        if (progress <= 0) {
          return 0;
        }

        return progress;
      },
      duration() {
        return state.duration;
      },
      head() {
        const programDate = this.currentProgram.sinceDate;
        if (!programDate) {
          return;
        }

        return +((state.head / this.duration) * 100).toFixed(2);
      },
    },
    methods: {
      seek(clickPosition) {
        const position = (clickPosition / 100) * this.duration;
        const diff = state.progress - position;

        if (!isNaN(diff)) {
          setSeekTo(diff);
        }
      },
      hover({ left, offsetWidth }) {
        const programSinceDate = this.currentProgram.sinceDate;
        if (!programSinceDate) {
          return;
        }

        this.hoverTimeFromProgramStart = (left / offsetWidth) * this.duration;
        const hoverTimeBase = programSinceDate.add(this.hoverTimeFromProgramStart, 's');
        this.displayedHoverTime = hoverTimeBase.format('HH:mm:ss');
        this.hoverTimeFromUnixZeroSec = hoverTimeBase.unix();

        if (this.previewUrl && this.isBeforeHead) {
          this.getChannelSprite();
        }
      },
    },
  };
</script>
